// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { PATH_REPORT_EXPORT } from './constants'
import { LabeledInput } from 'components/Form'
import ExportTypes from './ExportTypes'
import UnderlineCheck from './UnderlineCheck'
import validate from './validate'

const btnBase = 'heading-font btn btn-md hover-inverse'

const Form = props => {
  const {
    closeModal,
    error,
    handleSubmit,
    idRoot,
    supportUnderline,
  } = props

  return (
    <form className={'path-db-export-paths'}>
      {
        error &&
        <p className={'error-message'}>{error}</p>
      }
      <Field
        autoFocus={true}
        className={'show-error-on-focus'}
        component={LabeledInput}
        id={`${idRoot}report-name`}
        name={'fileName'}
        placeholder={'Report Name'} />
      <ExportTypes
        idRoot={`${idRoot}report-format`} />
      {
        supportUnderline &&
        <UnderlineCheck
          idRoot={`${idRoot}underline`} />
      }
      <div className={'display-flex justify-content-between width-2-3 margin-0-auto'}>
        <p
          className={`${btnBase} bg-grey-dark center-text`}
          onClick={closeModal}>
          {'Cancel'}
        </p>
        <button
          className={`${btnBase} bg-blue margin-left-1`}
          onClick={handleSubmit}>
          {'Submit'}
        </button>
      </div>
    </form>
  )
}

Form.propTypes = {
  change: func.isRequired,
  closeModal: func.isRequired,
  error: string,
  handleSubmit: func.isRequired,
  idRoot: string.isRequired,
  supportUnderline: bool,
}

const initialValues = {
  'fileName': '',
  'pathExportTypes': [],
  'underline': [],
}

export default reduxForm({
  form: PATH_REPORT_EXPORT,
  initialValues,
  validate,
})(Form)
